export default "https://cdn-static.gokick.com/assets/1a6b0e419037e7f05bc52ad73a019b5bb7bc4745/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";